/**
 * core/canvas-texture.js
 * Tiện ích khởi tạo Canvas 2D và THREE.CanvasTexture chuẩn hóa (Pixel Art & Mipmaps)
 */

import * as THREE from 'three';

/**
 * Tạo canvas 2D với kích thước width, height (hoặc hình vuông nếu chỉ truyền 1 tham số)
 * @param {number} width - Chiều rộng canvas
 * @param {number} [height] - Chiều cao canvas (mặc định bằng width)
 * @returns {HTMLCanvasElement}
 */
export function createCanvas(width, height = width) {
  const canvas = document.createElement('canvas');
  canvas.width = width;
  canvas.height = height;
  return canvas;
}

/**
 * Chuyển đổi HTMLCanvasElement thành THREE.CanvasTexture với cấu hình lọc và không gian màu chuẩn
 * @param {HTMLCanvasElement} canvas - Canvas nguồn
 * @param {object} [options] - Tuỳ chọn cấu hình
 * @param {boolean} [options.pixelated=true] - Bật NearestFilter cho phong cách Voxel Pixel Art
 * @param {string} [options.colorSpace] - Không gian màu (THREE.SRGBColorSpace...)
 * @returns {THREE.CanvasTexture}
 */
export function canvasToTexture(canvas, options = {}) {
  const texture = new THREE.CanvasTexture(canvas);
  const pixelated = options.pixelated !== false;
  if (pixelated) {
    texture.magFilter = THREE.NearestFilter;
    texture.minFilter = THREE.NearestFilter;
    texture.generateMipmaps = false;
  }
  if (options.colorSpace) {
    texture.colorSpace = options.colorSpace;
  }
  texture.needsUpdate = true;
  return texture;
}
